import axios from '@axios';

const base = '/api/v1/purple-scribe/summaries';

export default {
  list(id) {
    return axios.get(`${base}/visit/${id}`);
  },
}
